import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'madero-terms',
    imports: [],
    templateUrl: './terms.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './terms.component.scss'
})
export class TermsComponent {

}
